import React from 'react';

import { default as SettingsPersonal } from '../../components/Settings/PersonalData'

import MainBlockHeader from '../MainBlockHeader'
import MainBlockContainer from '../MainBlockContainer';
import { useTranslation } from 'react-i18next';

export default function Personal() {
  //let { userUid } = useParams();
  const { t } = useTranslation();

  return (
    <>
      <MainBlockHeader header={t('settingsPersonal.pageTitile')} >
      </MainBlockHeader>

      <MainBlockContainer>
        <SettingsPersonal />
      </MainBlockContainer>
    </>
  );
}

